import styled from 'styled-components';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  align-items: flex-start;
  height: ${(props) => props.$height};
  margin-bottom: ${(props) => props.$marginBottom || 'none'};
`;

const Editor = styled.div`
  border: 1px solid #eaedf3;
  padding: 24px;
  display: flex;
  width: 100%;
  min-height: 124px;
`;

const Label = styled.label`
  color: ${(props) =>
    props.error ? props.theme.COLOR_ERROR_TEXT : props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

const StyledEditor = {
  MainContainer,
  Editor,
  Label,
};

export default StyledEditor;
